export const BANK_CALL_GUIDE_MODAL = {
  JPN: {
    title: (
      <>
        海外送金のために銀行から問い合わせが来ることもあります。
        <br />
        そういう時はこう答えてください。
      </>
    ),
    questionTitle: 'ぎんこう',
    questionText: 'Successmodeとはどのような関係ですか?',
    answerTitle: 'あなた',
    answerText:
      "Successmodeは還付窓口運営事業者として 「TAX REFUND」を代行します。 (代表者 'Ju Byeong-Cheon' に入金されることがあります。)",
    btnTitle: '確認',
  },
  CHN: {
    title: (
      <>
        因为海外汇款，银行可能会来咨询。
        <br />
        那种时候请这样回答。
      </>
    ),
    questionTitle: '银行',
    questionText: '与Successmode是什么关系?',
    answerTitle: '您',
    answerText:
      'Successmode作为退税窗口事业者代理Tax Refund。(代表人名 "Ju Byeong-Cheon" 可汇款。)',
    btnTitle: '确认',
  },
};

export const BANK_CALL_GUIDE = {
  JPN: {
    title: (
      <>
        海外送金のために銀行から問い合わせが来ることもあります。
        <br />
        そういう時はこう答えてください。
      </>
    ),
    questionTitle: 'ぎんこう',
    questionText: 'Successmodeとはどのような関係ですか?',
    answerTitle: 'あなた',
    answerText:
      'Successmodeは還付窓口運営事業者として 「TAX REFUND」を代行します。 (代表者 "Ju Byeong-Cheon" に入金されることがあります。)',
  },
  CHN: {
    title: (
      <>
        因为海外汇款，银行可能会来咨询。
        <br />
        那种时候请这样回答。
      </>
    ),
    questionTitle: '银行',
    questionText: '与Successmode是什么关系?',
    answerTitle: '您',
    answerText:
      'Successmode作为退税窗口事业者代理 Tax Refund。(代表人名"JuByeong-Cheon")',
  },
};
